// extracted by mini-css-extract-plugin
export default {"main":"content_main__3Q4s5","box":"content_box__ntpnk"};